import type { NextPage } from "next";
import NextImage from "next/legacy/image";

import bg from "../assets/termsHeader.png";
import SEO from "../components/Seo/Seo";
import { CutoutAsset } from "../components/CutoutAsset/CutoutAsset";

const Terms: NextPage = () => {
  return (
    <>
      <SEO title="Terms &amp; Conditions | Coinage Media" />
      <div className="roadmap-header flex h-[80vh] tab:h-[66vh] bg-coinage-purple relative overflow-hidden">
        <div className="hidden tab:flex absolute overflow-hidden z-0 right-0  w-2/3 h-full about-image-holder">
          <CutoutAsset image={bg} right={false} color="purple" />
        </div>
        <div className="tab:hidden absolute bottom-0 overflow-hidden z-0 right-0  w-full h-[65%] about-image-holder">
          <CutoutAsset image={bg} mobile={true} color="purple" />
        </div>
        <div className=" flex mt-[60px] tab:mt-auto mb-auto z-1 relative mx-[auto] max-w-[1200px] w-full px-4">
          <h1 className=" display1 text-coinage-white max-w-[720px]">
            Terms &amp; Conditions.
          </h1>
        </div>
      </div>

      <div className="bg-coinage-offWhite pt-20 pb-20">
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          These terms and conditions of use, together with any documents and
          additional policies and guidelines they incorporate by reference
          (collectively, these “Terms”), are entered into between Trustless
          Media Inc., a Delaware corporation (together with any and all
          affiliates, “Trustless Media”, “We”, “Us” or “Our”), and You or the
          company or other legal entity that You represent (“You” or “Your”).
          Please read these Terms carefully as they govern Your use of our sites
          located at trustless.media and coinage.media, and all affiliated and
          associated sites, domains, subdomains, communications channels,
          addresses and directories (the “Sites”) and any of Trustless Media’s
          websites, multimedia, videos, audio, artwork, podcasts, materials,
          marketplaces, stores, products, services, presentations or other
          provided services, including but not limited to the Trustless Media
          interface, dashboard, website, and any other such services provided by
          or through Trustless Media (“Services”) and describe Your rights and
          obligations and our disclaimers and limitations of legal liability. By
          accessing, using, participating in, or receiving any of the Sites or
          Services, or clicking “I agree” to these Terms, or otherwise
          acknowledging these Terms, You accept and agree to be bound by and to
          comply with these Terms. If You do not agree to these Terms, You shall
          avoid accessing or using our Sites or the Services. Further, core
          aspects of Our Services may be controlled by, affected by, or subject
          to Trustless Media.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You must have the capacity and authority to form a legally binding
          contract online either on behalf of an entity or as an individual.
          Accordingly, You represent that, if You are agreeing to these Terms on
          behalf of a company or other legal entity, You have the legal
          authority to bind such company or other legal entity to these Terms
          and You are the older of 18 years old or the age of majority where You
          reside, You can form a legally binding contract, and have the capacity
          and authority to enter into and to comply with the obligations under
          these Terms. You represent and warrant that You are not a citizen or
          resident of a state, country, territory or other jurisdiction that is
          sanctioned or embargoed (nor are you personally sanctioned or
          embargoed) by the United States, United Nations or the European Union
          or where Your use of the Sites or the Services would be illegal or
          otherwise violate any treaty, domestic or foreign law, rule, statute,
          regulation, or other directive, requirement or guideline, which is in
          force and applies to or otherwise governs, rules or regulates any
          person, property, activity, event or other matter, including any rule,
          order, judgment, directive or other requirement or guideline issued by
          any domestic or foreign federal, provincial or state, municipal, local
          or other governmental, regulatory, judicial or administrative
          authority having jurisdiction over Trustless Media, You, the Sites or
          the Services; or as otherwise duly enacted, enforceable by law, the
          common law or equity (the “Applicable Law”).
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Privacy Policy
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Please refer to our privacy policy for information about how we
          collect, use, share and otherwise process information about You.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Changes to these Terms
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We reserve the right, in Our sole discretion, to modify these Terms
          from time to time. If we make changes, we will provide You with notice
          of such changes by sending an email, posting a notice on the Sites or
          elsewhere on our Services or updating the date at the top of these
          Terms. Unless we say otherwise in our notice, any modifications are
          effective immediately upon such notification given as in the previous
          sentence, and Your continued use of the Sites or our Services will
          confirm Your consent and acceptance of the changes and to these
          revised Terms in full. If You do not agree to such revised Terms, You
          must stop using our Services.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          In order to use certain features of the Services, You may be required
          to register for an account and provide certain information about
          Yourself as prompted by the account registration form (the “Account”).
          You shall provide complete and accurate information where prompted by
          Us in the Sites and/or Services. You are responsible for maintaining
          the confidentiality of Your Account login information and are fully
          responsible for all activities that occur under and from Your Account.
          If applicable, Trustless Media may suspend or terminate Your Account
          for any reason at Our sole discretion, including for any use of the
          Sites or Services in violation of these Terms.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          DLT/Blockchain Payments and Fees
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Some Services offered by Us, whether merely by interface or link to
          external or third-party services, require payment with or otherwise
          involve the use of an underlying blockchain or other decentralized
          software infrastructure (the “Distributed Ledger Technology”), which
          may require that You pay a fee, such as (but not limited to) “gas”
          charges for the computational resources required to perform a
          transaction on the particular Distributed Ledger Technology (such
          payments and fees, “Charges”). You acknowledge and agree that
          Trustless Media has no control over any Distributed Ledger Technology
          transactions, the third-party services or products used to access
          Distributed Ledger Technology or payments thereon, the method of
          payment of any Charges, if applicable, or any actual payments of
          Charges or amounts thereto, if applicable. Accordingly, You must
          ensure that You have a sufficient balance of the applicable
          Distributed Ledger Technology network cryptocurrencies or tokens
          stored at Your Distributed Ledger Technology-compatible account
          address (“Distributed Ledger Technology Address”) to complete any such
          transaction on the Distributed Ledger Technology before initiating
          such transaction.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          As a condition to accessing or using the Services or the Sites, You:
          (i) will ensure that all information that You provide on the Sites or
          otherwise to Us is current, complete, and accurate (ii) will only use
          the Services and the Sites for lawful purposes and in accordance with
          these Terms; (iii) will maintain the security and confidentiality of
          access to Your Distributed Ledger Technology Address; and (iv) agree
          (A) that no Indemnitee (as defined below) will be responsible for any
          loss or damage incurred as the result of any interactions You have
          with other users of the Sites or Services; and (B) if there is a
          dispute between You and any other site or other user, no Indemnitee
          (as defined below) will be under any obligation to become involved.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          As a condition to accessing or using the Sites or the Services, You
          will not: (i) violate any Applicable Law, including, without
          limitation, any relevant and applicable privacy and data collection
          laws including GDPR, any relevant and applicable gambling, illicit
          contracting, misrepresentation, or fraud laws, and any relevant and
          applicable anti-money laundering and anti-terrorist financing laws, in
          each case as may be amended; (ii) Export, re-export, or transfer,
          directly or indirectly, any Trustless Media technology or data or data
          accessed through any of the Services in violation of applicable export
          laws or regulations; (iii) Infringe any intellectual property or other
          third-party right, or commit a tort or violation of criminal or
          contract law while using or involving any Site or the Service; (iv)
          Misrepresent the reliability or veracity of any content on the Sites
          or through the Services; (v) Use the Sites or Services in any manner
          that could interfere with, disrupt, negatively affect, or inhibit
          other users from their quiet enjoyment of the Sites or Services, or
          that could impair, disable, overwhelm, or otherwise alter the
          functioning of the Sites or Services in any manner; (vi) Attempt to
          circumvent any content filtering techniques or security or compliance
          measures that Trustless Media employs on the Sites or the Services, or
          attempt to access any service or area of the Sites or the Services
          that You are not authorized to access; (vii) Use any scraper or other
          automated means or interface not provided by us to access the Sites or
          Services or to extract data; (viii) Introduce or use any exploit,
          virus, malware, Trojan horse, worm, backdoor or other harmful software
          in the Sites or the Services; (ix) Post content or communications on
          the Sites or Services that are, in Our sole discretion, fraudulent,
          deceptive, libelous, defamatory, profane, obscene, pornographic,
          sexually explicit, lewd, vulgar, suggestive, harassing, hateful,
          threatening, offensive, discriminatory, bigoted, abusive,
          inflammatory, or otherwise objectionable; (x) Post content or
          communications on the Sites or Services containing unsolicited
          promotions, campaigns, or commercial messages or any user content
          designed to deceive the user of the Service; or (xi) Induce any other
          user or third party to engage in any of the activities prohibited
          under these Terms or otherwise violate these Terms.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You represent and warrant that You: (i) know, understand and accept
          the risks associated with Your use of the Sites and Services, using
          smart contracts and other blockchain and distributed ledger
          technologies, APIs, and public/private key technologies in general,
          Your Distributed Ledger Technology Address and the Distributed Ledger
          Technology, including the risks identified elsewhere in these Terms.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Trustless Media Rights
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Excluding any open source software or third-party software that the
          Sites or the Services incorporates, as between You and Trustless
          Media, Trustless Media owns the Sites and the Services, including all
          technology and other content used, displayed or provided on the Sites
          (including all intellectual property rights), and hereby grants You a
          limited, revocable, non-transferable, license to access and use those
          portions of the Sites and the Services that are proprietary to
          Trustless Media in accordance with their intended uses and in
          accordance with any other applicable licensing terms for the Sites and
          the Services in these Terms (collectively, the “Trustless Media
          License”). You acknowledge that the Sites and/or the Services may use,
          incorporate or link to certain open-source components and that Your
          use of the Sites and/or Services is subject to, and You will comply
          with any, applicable open-source licenses (collectively, “Open-Source
          Licenses”). Notwithstanding the foregoing, You may not resell, share,
          distribute or otherwise permit any third party to use the Sites or the
          Services or otherwise use the Sites or the Services in a manner that
          violates the Trustless Media License or any other Open-Source
          Licenses.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Trustless Media may direct to, host or provide links to content of
          third parties (“Third Party Content”). Trustless Media makes no
          representation regarding, and accepts no responsibility for, Third
          Party Content or for the accuracy, quality, ownership or reliability
          thereof. Your use of these links and the Third Party Content is at
          Your own risk. When You leave the Sites, You should be aware that our
          Terms no longer govern. You should review the applicable terms and
          policies, including privacy and data gathering practices, of any
          website to which You navigate from the Sites.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Any of Trustless Media&apos;s product or Service names, logos, and
          other marks used in the Sites or as a part of the Services, including
          Trustless Media’s name and logo are intellectual property owned by
          Trustless Media and/or affiliates. You may not use Trustless Media’s
          name and logo in a manner that may cause misrepresentations or
          confusion. Except as provided in the foregoing, You may not copy,
          imitate or use Our Intellectual Property without Our (or the
          applicable licensor’s) prior written consent. Trustless Media will be
          free to use, reproduce, license, and otherwise distribute any
          suggestions, comments, or other feedback provided by You to Trustless
          Media with respect to the Sites or Services (“Feedback”) provided to
          it as it sees fit, entirely without obligation or restriction of any
          kind, on account of intellectual property rights or otherwise.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You hereby grant to Trustless Media a royalty-free, fully paid-up,
          sublicense-able, transferable, perpetual, irrevocable, non-exclusive,
          worldwide license to use, copy, modify, create derivative works of,
          display, perform, publish and distribute, in any form, medium or
          manner, any content that is available to other users via the Sites as
          a result of Your use of the Sites (collectively, “Your Content”)
          through Your use of the Services or the Sites, excluding for purposes
          of this sentence any of Your Content the intellectual property rights
          of which You legally own and expressly preserve while using the
          Services or Sites. You represent and warrant that You own Your Content
          or have the right to grant the rights and licenses in these Terms
          applicable to your use of the Sites, Services and Your Content, and
          Your Content and Our use of Your Content does not and will not
          violate, misappropriate or infringe on any third party’s rights nor
          Applicable Law.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Suspension and Termination
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We may, at Our sole discretion, with or without prior notice to You
          (unless otherwise expressly agreed in writing), modify, suspend or
          disable, temporarily or permanently, the Services offered by Trustless
          Media, in whole or in part, for any reason whatsoever, including, but
          not limited to, as a result of a security incident. We will not be
          liable for any losses suffered by You resulting from any modification
          to any Services or from any suspension or termination, for any reason,
          of Your access to all or any portion of the Sites or the Services. The
          Terms shall survive any termination of Your access to the Sites or the
          Services, in addition to any other provision which by law or by its
          nature should survive.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Indemnification
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You shall defend, indemnify, and hold harmless Trustless Media, our
          affiliates and subsidiaries, and our and our affiliates’ and
          subsidiaries’ respective shareholders, members, directors, officers,
          employees, representatives, suppliers, licensors, attorneys, agents,
          and contractors (collectively, “Indemnitees”) from any claim, demand,
          lawsuit, action, proceeding, investigation, liability, damage, loss,
          costs or expenses, including without limitation reasonable attorneys’
          fees, arising out of or relating to Your use of, or conduct in
          connection with, the Sites, the Services, Distributed Ledger
          Technology assets associated with Your Distributed Ledger Technology
          Address, any other digital assets, Your Content; Your violation of
          these Terms; Your violation of any Applicable Law or regulations; Your
          gross negligence or intentional misconduct; or Your infringement or
          misappropriation of the rights of any other person or entity. If You
          are obligated to indemnify any Indemnitee, Trustless Media (or, at its
          discretion, the applicable Indemnitee) will have the right, in its
          sole discretion, to control any legal action or proceeding arising
          therefrom.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Notices and Communications
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You consent to receive all communications, policies, invoices,
          notices, and disclosures electronically (collectively, our
          “Communications”) that we provide in connection with these Terms or
          any Services. You agree that we may provide our Communications to You
          by posting them on any of the Sites or through the Services or by
          emailing them to You at any email address You provide in connection
          with using the Services. You may also contact us to request additional
          electronic copies of our Communications by
          emailing Contact@trustless.media.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Disclosures
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Trustless Media does not operate an exchange platform of any kind or
          offer trade execution or clearing services with respect to traditional
          or digital assets and therefore has no oversight, involvement, or
          control with respect to Your transactions pursuant to the Sites or
          Services or any Distributed Ledger Technology. You are responsible for
          complying with all Applicable Law and regulations applicable to Your
          transactions. Trustless Media does not own or control the underlying
          software protocols that are used in connection with the Sites and
          Services, including but not limited to the Ethereum network and Ether
          tokens. In general, the underlying protocols on which the Services are
          based are open-source and anyone can use, copy, modify, and distribute
          them. Trustless Media is not responsible for operation of the
          underlying protocols, and Trustless Media makes no guarantee of their
          functionality, security, or availability.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          To the maximum extent permitted under Applicable Law, the Sites and
          the Services (and any of their content or functionality) provided by
          or on behalf of Us are provided on an “AS IS” basis, and we expressly
          disclaim, and You hereby waive, any representations, conditions or
          warranties of any kind, whether express or implied, legal, statutory
          or otherwise, or arising from statute, otherwise in law, course of
          dealing, or usage of trade, including, without limitation, the implied
          or legal warranties and conditions of merchantability, quality or
          fitness for a particular purpose, title, security, availability,
          reliability, accuracy, quiet enjoyment and non-infringement of third
          party rights. Without limiting the foregoing, We do not represent or
          warrant that the Sites or the Services (including any related data)
          will be uninterrupted, available at any particular time or error-free.
          We do not warrant that errors in the Sites or the Service are
          correctable or will be corrected beyond good faith measures by Us, to
          the extent possible and practical.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You acknowledge that Your data on the Sites or through the Services
          may become permanently lost or corrupted or temporarily unavailable
          due to a variety of causes, and agree that, to the maximum extent
          permitted under Applicable Law, we will not be liable for any loss or
          damage caused by denial-of-service attacks, 51% attacks, software
          failures, lost private or public keys, viruses or other
          technologically harmful materials (including those which may infect
          Your computer equipment), protocol changes by third party providers,
          Internet outages, force majeure events or other disasters, scheduled
          or unscheduled maintenance, or other causes either within or outside
          our control. The disclaimer of implied warranties contained in these
          Terms may not apply if and to the extent such warranties cannot be
          excluded or limited under the Applicable Law of the jurisdiction in
          which You reside.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Limitation of Damages and Liability
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Trustless Media, together with any Indemnitee, shall not in any event
          be liable for any incidental, indirect, special, punitive, exemplary,
          consequential or similar damages or liabilities whatsoever (including,
          without limitation, damages for loss of data, information, revenue or
          other business or financial benefit) arising out of or in connection
          with any of the Sites and/or Services (and any of their content and
          functionality), any execution or settlement of a transaction, any
          performance or non-performance of the Services, Your Distributed
          Ledger Technology assets, other digital assets or any other product,
          service or other item provided by or on behalf of an Indemnitee,
          whether under contract, tort (including negligence), civil liability,
          statute, strict liability, breach of warranties, or under any other
          theory of liability, and whether or not any Indemnitee has been
          advised of, knew of or should have known of the possibility of such
          damages and notwithstanding any failure of the essential purpose of
          these Terms or any limited remedy nor is Trustless Media in any way
          responsible for the execution or settlement of transactions between
          users of the Services.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          In no event will the Indemnitees&apos; aggregate liability arising out
          of or in connection with the Sites and the Services (and any of their
          content and functionality), any performance or non-performance of the
          Services, Your Distributed Ledger Technology assets, other digital
          assets or any other product, service or other item provided by or on
          behalf of an Indemnitee, whether under contract, tort (including
          negligence), civil liability, statute, strict liability or other
          theory of liability exceed the amount of the fees paid by You to Us
          under these Terms in the one year period immediately preceding the
          event giving rise to the claim for liability.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">Waiver</p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          To the extent permitted by Applicable Law, in consideration for being
          allowed to use any of the Sites and the Services, You hereby release
          and forever discharge Trustless Media and all Indemnitees from, and
          hereby waive and relinquish, each and every past, present and future
          dispute, claim, controversy, demand, right, obligation, liability,
          action and cause of action of every kind and nature (including
          personal injuries, death, and property damage), that has arisen or
          arises directly or indirectly out of, or that relates directly or
          indirectly to, any of the Sites and/or the Services (including any
          interactions with, or act or omission of, other Sites, Services, or
          Trustless Media users or any third-party services). YOU HEREBY WAIVE
          ANY APPLICABLE PROVISION IN LAW OR REGULATION IN CONNECTION WITH THE
          FOREGOING, WHICH STATES IN SUBSTANCE: “A GENERAL RELEASE DOES NOT
          EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST
          IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF
          KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER
          SETTLEMENT WITH THE DEBTOR.”
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Arbitration
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          These terms require You to arbitrate certain disputes and claims with
          Trustless Media and limit the manner in which You can seek relief from
          us, unless You opt out of arbitration by following the instructions
          set forth below. In addition, arbitration precludes You from suing in
          court or having a jury trial. You and Trustless Media agree that any
          dispute arising out of or related to these Terms or our Services is
          personal to You and Trustless Media and that any dispute will be
          resolved solely through individual action, and will not be brought as
          a class arbitration, class action or any other type of representative
          proceeding.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You and Trustless Media waive Your rights to a jury trial and to have
          any dispute arising out of or related to these Terms or our Services
          resolved in court. For any dispute or claim that You have against
          Trustless Media or relating in any way to the Services, You agree to
          first contact Trustless Media and attempt to resolve the claim
          informally by sending a written notice of Your claim (“Notice”) to
          Trustless Media by email at Contact@trustless.media. The Notice must
          include Your name, residence address, email address, and telephone
          number, describe the nature and basis of the claim and set forth the
          specific relief sought. Our notice to You will be similar in form to
          that described above. If You and Trustless Media cannot reach an
          agreement to resolve the claim within thirty (30) days after such
          Notice is received, then either party may submit the dispute to
          binding arbitration administered by the American Arbitration
          Association (“AAA”), or, under the limited circumstances set forth
          above, in court. All disputes submitted to AAA will be resolved
          through confidential, binding arbitration before one arbitrator. The
          most recent version of the AAA Rules are available on the AAA
          Website and are hereby incorporated by reference. You acknowledge and
          agree that You have read and understand the AAA Rules or waive Your
          opportunity to read the AAA Rules and waive any claim that the AAA
          Rules are unfair or should not apply for any reason.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The arbitrator, Trustless Media, and You will maintain the
          confidentiality of any arbitration proceedings, judgments and awards,
          including, but not limited to, all information gathered, prepared and
          presented in relation to the disputes. The arbitrator will have the
          authority to make appropriate rulings to safeguard confidentiality,
          unless the law provides to the contrary. The duty of confidentiality
          does not apply to the extent that disclosure is necessary to prepare
          for or conduct the arbitration hearing on the merits, in connection
          with a court application for a preliminary remedy or in connection
          with a judicial challenge to an arbitration award or its enforcement,
          or to the extent that disclosure is otherwise required by law or
          judicial decision. You and Trustless Media agree that for any
          arbitration You initiate, You will pay the filing fee and any
          remaining AAA fees and costs.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Any claim arising out of or related to these Terms or our Services
          must be filed within one year after such claim arose; otherwise, the
          claim is permanently barred, which means that You or Trustless Media,
          as applicable, will not have the right to assert the claim. You have
          the right to opt out of binding arbitration within 30 days of the date
          You first accepted these Terms by emailing us
          at Contact@trustless.media.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Severability and Governing Law
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          If any portion of these Terms is found to be unenforceable or unlawful
          for any reason, the unenforceable or unlawful provision will be
          severed from these Terms, and the severance of the unenforceable or
          unlawful provision will have no impact whatsoever on the remainder or
          the parties’ ability to compel arbitration of any remaining claims on
          an individual basis, and to the extent that any claims must therefore
          proceed on a class, collective, consolidated, or representative basis,
          such claims must be litigated in a civil court of competent
          jurisdiction and not in arbitration, and the parties agree that
          litigation of those claims will be stayed pending the outcome of any
          individual claims in arbitration.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The interpretation and enforcement of these Terms, and any dispute
          related to these Terms, the Sites or the Services, will be governed by
          and construed and enforced in accordance with the laws of New York, as
          applicable, without regard to conflict of law rules or principles. You
          agree that we may initiate a proceeding related to the enforcement or
          validity of our intellectual property rights in any court having
          jurisdiction. With respect to any other proceeding that is not subject
          to arbitration under these Terms, the courts located in the State of
          New York will have exclusive jurisdiction. You waive any objection to
          venue in such courts.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Miscellaneous
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Any right or remedy of Trustless Media set forth in these Terms is in
          addition to any other right or remedy whether described in these
          Terms, under Applicable Law, at law or in equity. Our failure or delay
          in exercising any right, power, or privilege under these Terms will
          not operate as a waiver thereof. The illegality or unenforceability of
          any of these Terms will not affect the validity or enforceability of
          any other of these Terms, all of which will remain in full force and
          effect. We will have no responsibility or liability for any failure or
          delay in performance of the Sites or any of the Services, or any loss
          or damage that You may incur, due to any circumstance or event beyond
          our control, including without limitation any flood, extraordinary
          weather conditions, earthquake, or other act of God, fire, pandemic or
          infectious disease, war, insurrection, riot, accident, governmental
          condition, communications, power failure, or equipment or software
          malfunction. You may not assign or transfer any right to use any of
          the Sites or the Services, or any of Your rights or obligations under
          these Terms, without our express prior written consent, including by
          operation of law or in connection with any change of control. We may
          assign or transfer any or all of our rights or obligations under these
          Terms, in whole or in part, without notice or obtaining Your consent
          or approval. Headings of sections are for convenience only and will
          not be used to limit or construe such sections. These Terms contain
          the entire agreement and supersede all prior and contemporaneous
          understandings between the parties regarding the Sites and the
          Services. If there is a conflict between these Terms and any other
          agreement You may have with us, these Terms will control unless the
          other agreement specifically identifies these Terms and declares that
          the other agreement supersedes these Terms.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Contact Us
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Trustless Media Inc., a Delaware corporation c/o Cogency Global Inc.
          850 New Burton Road, Suite 201 Dover, DE 19904 Contact@trustless.media
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          © 2022 Trustless Media Inc.All rights reserved. All trademarks, logos
          and service marks displayed on the Sites and Services are Our property
          or the property of other third parties. If You have any questions or
          concerns regarding these Terms, please send Us a detailed message
          to Contact@trustless.media, and We will address Your concerns as soon
          as we can and to the best of our ability
        </p>
      </div>
    </>
  );
};

export default Terms;
